import {ChangeDetectorRef, Component, Renderer2, TemplateRef, ViewChild, ViewContainerRef} from '@angular/core';
import {animate, style, transition, trigger} from '@angular/animations';
import {HasSubscriptions} from '../has-subscriptions';
import {StyleService} from '../../services/style/style.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-drawer',
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.scss'],
  animations: [
    trigger('drawerTrigger', [
      transition(':enter', [
        style({height: '0'}),
        animate('500ms ease-out', style({height: '100vh'}))
      ]),
      transition(':leave', [
        style({height: '*'}),
        animate('500ms ease-in', style({height: '0'}))
      ])
    ])
  ]
})

export class DrawerComponent extends HasSubscriptions {

  @ViewChild('drawerContent', {read: ViewContainerRef}) drawerContentRef: ViewContainerRef;

  drawerOpen: boolean = false;

  constructor(private _renderer: Renderer2,
              private activatedRoute: ActivatedRoute, // do not remove this - without it all changes on local-dev require a complete rebuild for some reason
              private styleService: StyleService,
              private changeDetectorRef: ChangeDetectorRef) {
    super();
  }

  // dynamically inject template
  openDrawer<T>(drawerTemplate: TemplateRef<T>) {
    this.drawerOpen = true;
    this.changeDetectorRef.detectChanges(); // ensure ngif is rendered first
    this.drawerContentRef.clear();
    this.drawerContentRef.createEmbeddedView(drawerTemplate);
    this.styleService.addClass(this._renderer, 'html', 'no-scroll');
  }

  closeDrawer() {
    this.drawerContentRef.clear();
    this.drawerOpen = false;
    this.styleService.removeClass(this._renderer, 'html', 'no-scroll');
  }
}
